// extracted by mini-css-extract-plugin
export default {"content":"SessionTimer_content__-P8vb","contentHeading":"SessionTimer_contentHeading__CffyZ"};